import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { TableBox, SearchFilter, Paging } from '../../components';
import { usePagination, useFilter } from '../../hooks';
import { SnackbarContext } from '../../contexts';
import Button from '@mui/material/Button';
import Handler from '../../Handler';
import API from '../../api';

export const ReductionEvidenceListPage = (props) => {
  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [list, setList] = useState(null);
  const [header, setHeader] = useState([
    {
      key: 'seq',
      align: 'center',
      text: 'No',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'type',
      align: 'center',
      text: '상태',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        console.log('render value', value);
        switch (value) {
          case 'Document': {
            return '서면 모니터링';
          }
          case 'System': {
            return '시스템 모니터링';
          }
          default: {
            return '전체';
          }
        }
      },
    },
    {
      key: 'title',
      align: 'center',
      text: '증빙서류명',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'isForce',
      align: 'center',
      text: '상태',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        console.log('render value', value);
        switch (value) {
          case true: {
            return '필수';
          }
          default: {
            return '선택';
          }
        }
      },
    },
    {
      key: 'status',
      align: 'center',
      text: '상태',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        console.log('render value', value);
        switch (value) {
          case 'Valid': {
            return '사용 중';
          }
          default: {
            return '사용 안함';
          }
        }
      },
    },
    // {
    //   key: 'createdAt',
    //   align: 'center',
    //   text: '생성일',
    //   style: {
    //     minWidth: 100,
    //   },
    //   render: (value) => {
    //     return Handler.getYYYYMMDDByUnix(value);
    //   },
    // },
    // {
    //   key: 'updatedAt',
    //   align: 'center',
    //   text: '수정일',
    //   style: {
    //     minWidth: 100,
    //   },
    //   render: (value) => {
    //     return Handler.getYYYYMMDDByUnix(value);
    //   },
    // },
  ]);

  const [filter, onFilterChange, setFiler] = useFilter([
    {
      key: 'type',
      type: 'select',
      label: '모니터링 구분',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '전체',
        },
        {
          value: 'Document',
          label: '서면 모니터링',
        },
        {
          value: 'System',
          label: '시스템 모니터링',
        },
      ],
    },

    {
      key: 'searchValue',
      type: 'input',
      label: '타이틀명',
      value: '',
      inputType: 'text',
    },
  ]);
  const [page, totalPage, totalCount, onPageChange, setPage, setTotalPage, setTotalCount] = usePagination(0, 9);

  const tableCallback = (type, index) => {
    console.log('tableCallback type', type);
    console.log('tableCallback index', index);
  };

  const tableRowClick = (index) => {
    console.log('tableRowClick index', index);
    let target_seq = list[index].seq;
    console.log('tableRowClick target_seq', target_seq);

    history.push('/reduction/evidence/detail/' + target_seq);
  };

  const onSearch = (body) => {
    console.log('onSearch', body);
    requestNewList(0);
  };

  useEffect(() => {
    console.log('page effect', page);
    requestNewList();
  }, [page]);

  const requestNewList = (init_page) => {
    let body = Handler.filterToBody(filter);
    console.log('page body', body);
    API.MonitoringEvidence.GetEvidence({
      ...body,
      searchType: 'Title',
      page: init_page ? init_page : page,
      size: Handler.VARIABLES.PAGE_LIMIT,
    }).then(
      (res) => {
        console.log('res', res);
        let result = res.data;
        setList(result.content);
        setTotalPage(result.totalPages);
      },
      (err) => {
        console.log('err', err);
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  const requsetAdd = () => {
    console.log('requsetAdd');
    history.push('/reduction/evidence/add');
  };

  console.log('list', list);

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>모니터링 증빙서류 목록</h3>
        </header>
        <div className='button__box'>
          <Button variant='contained' onClick={requsetAdd}>
            추가
          </Button>
        </div>
      </section>
      <section className='filter__container'>
        <SearchFilter data={filter} onChange={onFilterChange} onSearch={onSearch}></SearchFilter>
      </section>
      <section className='table__container'>
        <TableBox data={list} header={header} rowClick={tableRowClick} callback={tableCallback}></TableBox>
      </section>
      <section className='paging__container'>
        <Paging page={page} totalPage={totalPage} onChange={onPageChange}></Paging>
      </section>
    </article>
  );
};
